import { Store } from '@betgames/bg-state-manager';
import { IPLSGameId } from '@bg-shared/interfaces/GameId';
import { IGameBlackjackDraw } from '@bg-shared/interfaces/Draws/IBlackjackDraw';
import { IGameBlackjackModel } from './interfaces/IGameBlackjackModel';

export default class GameBlackjackStore extends Store<IGameBlackjackModel> {
    constructor() {
        super({
            key: 'gameBlackjack',
            default: {
                data: null,
            },
        });
    }

    public updateGame(gameId: IPLSGameId, data: IGameBlackjackDraw): void {
        this.update((draft) => {
            if (!draft.data) {
                draft.data = {};
            }

            draft.data[gameId] = data;
        });
    }
}

export const gameBlackjackStore = new GameBlackjackStore();
